export enum ProfilesEnum {
    EXPERT = "EXPERT",
    PRACTITIONER = "PRACTITIONER",
    CLIENT = "CLIENT",
    ADMIN = "ADMIN"
}